/* ==========================================================================
   LUK combo product page.

   "Add to cart" adds the box as one line at its own price. It is kept out
   of the LUK collection so the every-3 offer cannot price boxes as loose
   perfumes. Cards in "Add more like this" add single perfumes. Both open
   the cart drawer with Dawn's own renderer.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__lukComboInit) return;
  window.__lukComboInit = true;

  var BUSY = false;

  function sections() {
    var ids = [];
    if (document.getElementById('CartDrawer')) ids.push('cart-drawer', 'cart-icon-bubble');
    return ids;
  }

  function openDrawer(payload) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function' || !payload || !payload.sections) return false;
    try {
      drawer.renderContents(payload);
    } catch (e) {
      return false;
    }
    requestAnimationFrame(function () {
      if (typeof drawer.open === 'function' && !drawer.classList.contains('active')) drawer.open();
    });
    return true;
  }

  function addToCart(items, button, errorEl) {
    if (BUSY || !items.length) return;
    BUSY = true;
    if (button) {
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
    }
    if (errorEl) errorEl.hidden = true;

    var root = document.querySelector('[data-luk-combo]');
    var addUrl = (root && root.dataset.cartAddUrl) || (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: sections().join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (r) {
        if (!r.ok || r.data.status) {
          throw new Error(r.data.description || r.data.message || 'Could not add to cart');
        }
        if (!openDrawer(r.data)) {
          window.location.href = (root && root.dataset.cartUrl) || '/cart';
        }
      })
      .catch(function (err) {
        if (errorEl) {
          errorEl.textContent = err.message || 'Something went wrong. Please try again.';
          errorEl.hidden = false;
        }
      })
      .finally(function () {
        BUSY = false;
        if (button) {
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
        }
      });
  }

  /* ---------- clicks ---------- */
  document.addEventListener('click', function (evt) {
    var boxBtn = evt.target.closest('[data-combo-add]');
    if (boxBtn) {
      evt.preventDefault();
      var root = document.querySelector('[data-luk-combo]');
      if (!root) return;
      var shell = parseInt(root.dataset.shellVariant, 10);
      if (!shell) return;
      var items = [{ id: shell, quantity: 1 }];
      addToCart(items, boxBtn, root.querySelector('[data-combo-error]'));
      return;
    }

    var moreBtn = evt.target.closest('[data-more-add]');
    if (moreBtn) {
      evt.preventDefault();
      addToCart([{ id: parseInt(moreBtn.getAttribute('data-more-add'), 10), quantity: 1 }], moreBtn, null);
      return;
    }

    var jump = evt.target.closest('[data-combo-scroll]');
    if (jump) {
      var hash = jump.getAttribute('href');
      if (!hash || hash.charAt(0) !== '#') return;
      var target = document.querySelector(hash) || document.querySelector('.jdgm-widget, .jdgm-rev-widg');
      if (!target) return;
      evt.preventDefault();
      var header = document.querySelector('.section-header, sticky-header');
      var offset = header ? header.getBoundingClientRect().height : 0;
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset - 12, behavior: 'smooth' });
    }
  });

  /* ---------- gallery ---------- */
  function initGallery() {
    var gallery = document.querySelector('[data-combo-gallery]');
    if (!gallery) return;
    var stage = gallery.querySelector('[data-combo-stage]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-combo-thumb]'));
    if (!stage || !thumbs.length) return;

    function setActive(index) {
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
        t.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        stage.scrollTo({ left: stage.clientWidth * i, behavior: 'smooth' });
        setActive(i);
      });
    });

    var ticking = false;
    stage.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          setActive(Math.round(stage.scrollLeft / Math.max(1, stage.clientWidth)));
        });
      },
      { passive: true }
    );
  }

  /* ---------- reviews ---------- */
  /* Judge.me renders its own widget; ask it for three reviews a page so the
     rest falls to its pagination. The definitive setting lives in the
     Judge.me admin — this only nudges the widget on this template. */
  function limitReviews() {
    var PER_PAGE = 3;
    function apply() {
      document.querySelectorAll('.jdgm-paginate').forEach(function (el) {
        if (el.getAttribute('data-per-page') !== String(PER_PAGE)) {
          el.setAttribute('data-per-page', String(PER_PAGE));
        }
      });
    }
    apply();
    if (!('MutationObserver' in window)) return;
    var seen = new MutationObserver(apply);
    seen.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      seen.disconnect();
    }, 15000);
  }

  /* ---------- reviews pager ---------- */
  function initReviews() {
    var root = document.querySelector('[data-luk-reviews]');
    if (!root) return;
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-review-page]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-review-page-to]'));
    var prev = root.querySelector('[data-review-prev]');
    var next = root.querySelector('[data-review-next]');
    if (!items.length) return;
    var last = 0;
    items.forEach(function (el) {
      last = Math.max(last, parseInt(el.getAttribute('data-review-page'), 10) || 0);
    });
    var page = 0;

    function show(to) {
      page = Math.min(Math.max(to, 0), last);
      items.forEach(function (el) {
        el.hidden = parseInt(el.getAttribute('data-review-page'), 10) !== page;
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === page);
      });
      if (prev) prev.disabled = page === 0;
      if (next) next.disabled = page === last;
    }

    if (prev) prev.addEventListener('click', function () { show(page - 1); });
    if (next) next.addEventListener('click', function () { show(page + 1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        show(parseInt(d.getAttribute('data-review-page-to'), 10) || 0);
      });
    });
    show(0);
  }

  function init() {
    initGallery();
    limitReviews();
    initReviews();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
